var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-pulled-right"},[_c('router-link',{staticClass:"button is-small is-primary",attrs:{"to":_vm.path}},[_vm._v("\n   "+_vm._s(_vm.displayText)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }